import Application from "../../Application";
import Report6Presenter, {
  IReport6Presenter
} from "../../presenter/report/Report6Presenter";
import { IReportService } from "../../service/report/ReportService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowReport6PageInteractor {
  private application: Application;
  private output?: IReport6Presenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getReportingPeriods() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report6Presenter({
      application: this.application,
      initialState: {
        report6ReportingPeriodList: [],
        report6Applicants: [],
        report6SelectedApplicantIds: undefined,
        report6SelectedReportingPeriod: undefined,
        report6ReportApplicants: undefined
      }
    });

    this.getReportingPeriods().then(
      (reportingPeriods) =>
        this.output && this.output.setReportingPeriods(reportingPeriods)
    );

    return this.output;
  }
}
